import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import InputPass from './commponents/inputPass';
import Button from './commponents/Button';

import containerActions from './actions';

import './styles.scss';


class AdminRestorePass extends Component {
  constructor () {
    super();
    this.state = {
      pass: '',
      passConfirm: ''
    };
  }

  typePass = (e) => {
    this.setState({
      pass: e.target.value
    });
  }
  typePassConfirm = (e) => {
    this.setState({
      passConfirm: e.target.value
    });
  }

  sendNewPass = () => {
    const test = this.props;
    const { match: { params: { id } } } = test;
    if (this.state.pass === this.state.passConfirm) {
      this.props.AdmiPassRestore({
        keygen: id,
        password: this.state.pass
      });
    }
  }
  render() {
    return (
      <div className="pageResetPass-body">
        <div className="pageResetPass-mainField">
          <InputPass caption="NEW PASSWORD" onChange={this.typePass} />
          <InputPass caption="CONFIRM NEW PASSWORD" onChange={this.typePassConfirm} />
          <Button
            Caption="OK"
            buttonStyle="adminButton"
            Disabled={
              this.state.pass.length === 0 ||
              this.state.passConfirm.length === 0 ||
              this.state.pass !== this.state.passConfirm
            }
            onHandleClick={this.sendNewPass}
          />
        </div>
      </div>
    );
  }
}
AdminRestorePass.propTypes = {
  AdmiPassRestore: PropTypes.func.isRequired
};

const mapStateToProps = () => ({

});

export default connect(mapStateToProps, containerActions)(AdminRestorePass);



// WEBPACK FOOTER //
// ./src/pages/AdminRestorePass/index.js